import AdaptiveCardsStyleOptions from '/druid/AdaptiveCardsStyleOptions';

const ADAPTIVE_CARDS_DEFAULT_STYLE_OPTIONS: Required<AdaptiveCardsStyleOptions> = {
  adaptiveCardsParserMaxVersion: undefined,
  cardEmphasisBackgroundColor: '#F9F9F9',
  cardPushButtonBackgroundColor: '#0063B1',
  cardPushButtonTextColor: 'White',
  richCardWrapTitle: false
};

export default ADAPTIVE_CARDS_DEFAULT_STYLE_OPTIONS;
